import { Currency } from '@/core/currency/interfaces';

const BOB: Currency = {
    name: 'Bolivian Boliviano',
    demonym: 'Bolivian',
    majorSingle: 'Boliviano',
    majorPlural: 'Bolivianos',
    codeNumeric: '068',
    symbol: 'Bs.',
    symbolNative: 'Bs.',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BOB',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BOB;
